import { defineComponent as _defineComponent } from 'vue'
import { Product } from '@/models/product_model';
import { ref } from 'vue';
import { FormatUtils } from '@/infra/utils/format.utils';
import PlusMinus from './PlusMinus.vue';
import { Icons } from '@/font-awesome';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ExpiresCard from './ExpiresCard.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCard',
  props: {
    product: { type: Object, required: true },
    amountInCart: { type: Number, required: false },
    stockQuantity: { type: Number, required: true }
  },
  emits: ["remove-from-cart", "set-amount", "add-to-cart"],
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;



const photoUrl = props.product.getPhotoUrl();

const isHovered = ref(false);


const __returned__ = { props, photoUrl, isHovered, get FormatUtils() { return FormatUtils }, PlusMinus, get Icons() { return Icons }, get FontAwesomeIcon() { return FontAwesomeIcon }, ExpiresCard }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})